import { Dialog, DialogContent, DialogTitle, Grid, MenuItem } from '@mui/material'
import InputDatePicker from '../../../component/input/inputDatePicker'
import moment from 'moment'
import FilterSelect from '../../../component/select/filterSelect'
import AutocompleteSelect from '../../../component/select/autoCompleteSelect'
import ClearIcon from '@mui/icons-material/Clear';
import { getYearOptions } from '../../../utils/app.utils'


type PropsDialogFilter = {
    openFilter: boolean
    setOpenFilter: any
    sdate: string
    setSdate: any
    edate: string
    setEdate: any
    keywordLevel1?: string;
    setKeywordLevel1?: any;
    keywordLevel2?: string;
    setKeywordLevel2?: any;
    keywordLevel3?: string;
    setKeywordLevel3?: any;
    keywordLevel4?: string;
    setKeywordLevel4?: any;
    idDepartment?: string;
    folderName?: any;
    idFiscalYear?: string;
    setIdFiscalYear?: any
    sortBy?: string;
    sortType?: string;
    setSortType?: any
}


export default function DialogFilter(props: PropsDialogFilter) {
        const yearOptions = getYearOptions();
    
    const { openFilter, setOpenFilter, sdate, setSdate, edate, setEdate, folderName, keywordLevel1, keywordLevel2, keywordLevel3, keywordLevel4,
        setKeywordLevel1, setKeywordLevel2, setKeywordLevel3, setKeywordLevel4, idFiscalYear, setIdFiscalYear
    } = props

    return (
        <Dialog
            open={openFilter}
            onClose={() => setOpenFilter(false)}>
            <DialogTitle sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                <ClearIcon sx={{ cursor: 'pointer', fontSize: "20px" }} onClick={() => {
                    setOpenFilter(false)
                }} />
            </DialogTitle>
            <DialogContent>
                <Grid container columns={12} sx={{ marginBottom: '12px', gap: '12px' }}>
                    <Grid xs={12} sx={{ marginRight: '10px' }}>
                        <InputDatePicker
                            dateFormat="DD/MM/YYYY"
                            required={false}
                            key={""}
                            disabled={false}
                            label=""
                            maxDate={edate}
                            value={sdate}
                            onClear={() => setSdate('')}
                            onChange={(e: any) => setSdate(moment(e).format("YYYY-MM-DD"))
                            }
                            allowClear
                            heading={'ตั้งแต่วันที่'} />
                    </Grid>
                    <Grid xs={12} sx={{ marginRight: '10px' }}>

                        <InputDatePicker
                            dateFormat="DD/MM/YYYY"
                            required={false}
                            key={""}
                            disabled={false}
                            label=""
                            minDate={sdate}
                            value={edate}
                            onClear={() => setEdate('')}
                            onChange={(e: any) => setEdate(moment(e).format("YYYY-MM-DD"))
                            }
                            allowClear
                            heading={'ถึงวันที่'} />
                    </Grid>
                    <Grid xs={12} sx={{ marginRight: '10px' }}>

                        <AutocompleteSelect
                            options={folderName?.level1}
                            // disabled={location.state.params.isView}
                            getOptionLabel={(option: any) => option}
                            labelId="addmin-type"
                            inputValue={keywordLevel1}
                            heading={'ตู้เอกสาร/หน่วยงาน'}
                            placeholder='ทั้งหมด'
                            onInputChange={(event, newValue) => {
                                setKeywordLevel1(newValue)
                            }}
                            // required
                            helperText={''}
                        />
                    </Grid>
                    <Grid xs={12} sx={{ marginRight: '10px' }}>

                        <AutocompleteSelect
                            options={folderName?.level2}
                            // disabled={location.state.params.isView}
                            getOptionLabel={(option: any) => option}
                            labelId="addmin-type"
                            inputValue={keywordLevel2}
                            heading={'ชั้นเอกสาร'}
                            placeholder='ทั้งหมด'
                            onInputChange={(event, newValue) => {
                                setKeywordLevel2(newValue)
                            }}
                            // required
                            helperText={''}
                        />
                    </Grid>
                    <Grid xs={12} sx={{ marginRight: '10px' }}>

                        <AutocompleteSelect
                            options={folderName?.level3}
                            // disabled={location.state.params.isView}
                            getOptionLabel={(option: any) => option}
                            labelId="addmin-type"
                            inputValue={keywordLevel3}
                            heading={'แฟ้มเอกสาร'}
                            placeholder='ทั้งหมด'
                            onInputChange={(event, newValue) => {
                                setKeywordLevel3(newValue)
                            }}
                            // required
                            helperText={''}
                        />
                    </Grid>
                    <Grid xs={12} sx={{ marginRight: '10px' }}>
                        <AutocompleteSelect
                            options={folderName?.level4}
                            // disabled={location.state.params.isView}
                            getOptionLabel={(option: any) => option}
                            labelId="addmin-type"
                            inputValue={keywordLevel4}
                            heading={'ประเภทเอกสาร'}
                            placeholder='ทั้งหมด'
                            onInputChange={(event, newValue) => {
                                setKeywordLevel4(newValue)
                            }}
                            // required
                            helperText={''}
                        />
                    </Grid>
                    <Grid xs={12} sx={{ marginRight: '10px' }}>
                        <FilterSelect heading='ปีงบประมาณ' labelId='' selectId='' options={[{ value: 'all', name: 'ทั้งหมด' }, ...yearOptions].map((x, i) => {
                            return (
                                <MenuItem key={i}
                                    value={x.value}
                                >
                                    {x.name}
                                </MenuItem>
                            )
                        })} value={idFiscalYear} onchange={(e: any) => { setIdFiscalYear(e.target.value) }} />
                    </Grid>
                </Grid>
            </DialogContent>
        </Dialog>
    )
}
